module.exports = __webpack_public_path__ + "fonts/Inter-200-greek-ext31.2d64d8a.woff2";